import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { WorkflowTemplateService } from 'src/app/Service/workflow-template/workflow-template.service';

@Component({
	selector: 'app-wftd-bottom-kendo',
	templateUrl: './wftd-bottom-kendo.component.html',
	styleUrls: ['./wftd-bottom-kendo.component.css']
})
export class WftdBottomKendoComponent implements OnInit {
	@Output() changeWorkflowStatus = new EventEmitter<any>();
	enableFilter = false;
	enableFullscreen = false;
	bottomKendoList: any = [];

	constructor(
		public workflowTemplateService: WorkflowTemplateService,
	) { }

	ngOnInit() {
		this.workflowTemplateService.supportForBottomKendo.subscribe(data => {
			this.bottomKendoList = data;
		});
	}

	toggleFilter() {
		this.enableFilter = !this.enableFilter;
	}

	WorkflowStepDetails_onEdit(data: any) {
		this.changeWorkflowStatus.next(data);
	}

	toggleFullscreen() {
		this.enableFullscreen = !this.enableFullscreen;
	}
}
